module.exports = __webpack_public_path__ + "f96f931611cba2a597b510a81fb1e525.png";